import { useEffect } from 'react';
import { useLocation } from 'react-use';

import { AlertBanner as AUIAlertBanner } from '@soluto-private/mx-asurion-ui-react';

import {
  useAlertBannerAtomValue,
  useResetAlertBannerAtom,
} from '@service-initiation/tech-care-data-access-store';

export const AlertBanner = () => {
  const alertBanner = useAlertBannerAtomValue();
  const resetAlertBanner = useResetAlertBannerAtom();
  const location = useLocation();

  useEffect(() => {
    if (
      alertBanner &&
      alertBanner.skipResetOnPaths?.length &&
      location.pathname &&
      !alertBanner.skipResetOnPaths.includes(location.pathname)
    ) {
      resetAlertBanner();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <AUIAlertBanner
      alertBannerType={alertBanner?.bannerType}
      isOpen={alertBanner?.message !== undefined}
      onCloseClick={() => resetAlertBanner()}
    >
      {alertBanner?.message}
    </AUIAlertBanner>
  );
};
